<template>
  <div class="container">
    <!-- Your HTML content here -->
    线路波形图
  </div>
</template>

<script>
export default {
  name: "MyComponent",
  data() {
    return {
      message: "Hello World"
    };
  },
  methods: {
    myMethod() {
      console.log(this.message);
    }
  }
};
</script>

<style scoped>
/* Your styles here */
</style>